const apps = [
  {
    domain: 'www.luckyair.net',
    name: '祥鹏航空',
    sortName: '祥鹏',
    airline: '8L',
    logo: 'icon-logo8L',
    hotline: '95326',
    apiKey: 'usercenter.config.airline.67c53194.domain=luckyair.net'
  },
  {
    domain: 'www.fuzhou-air.cn',
    name: '福州航空',
    sortName: '福航',
    airline: 'FU',
    logo: 'icon-logoFU',
    hotline: '95071666',
    apiKey: 'usercenter.config.airline.79b5e4e45df93f47fu.domain=fuzhou-air.cn'
  },
  {
    domain: 'www.yzr.com.cn',
    name: '金鹏航空',
    sortName: '金鹏',
    loginOwnerTitle: '金鹏航空官网',
    loginFfpTitle: '金鹏俱乐部会员',
    airline: 'Y8',
    logo: 'icon-logoY8',
    hotline: '95071888',
    apiKey: 'usercenter.config.airline.79b5e4e45df93f47fu.domain=fuzhou-air.cn'
  },
  {
    domain: 'www.urumqi-air.com',
    name: '乌鲁木齐航空',
    sortName: '乌航',
    airline: 'UQ',
    logo: 'icon-logoUQ',
    hotline: '95334',
    apiKey: 'usercenter.config.airline.79b5e4e45df93f47fu.domain=fuzhou-air.cn'
  },
  {
    domain: 'www.jdair.net',
    name: '首都航空',
    sortName: '首航',
    airline: 'JD',
    logo: 'icon-logoJD',
    hotline: '95375',
    apiKey: 'usercenter.config.airline.79b5e4e45df93f47fu.domain=fuzhou-air.cn'
  }
]

export default function () {
  if (window.__MICRO_ROOT__) {
    const app = apps.find(item => item.airline === window.__MICRO_ROOT__.airline.toLocaleUpperCase())

    return app || apps[0]
  }

  return apps[0]
}
